<template>
  <div class="main">
    <product-banner class-name="productBg" :title="banner.title" :desc="banner.desc"></product-banner>

    <div class="advantage">
      <div class="advantage-container w">
        <div class="m-title">
          <h2>产品优势</h2>
        </div>
        <ul class="advantage-nav">
          <li v-for="item in advantageList" :key="item.id">
            <svg-icon :icon-class="item.svg" class-name="advantage-svg"></svg-icon>
            <h3>{{item.name}}</h3>
            <p>{{item.content}}</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="fun">
      <div class="fun-container w">
        <div class="m-title">
          <h2>产品功能</h2>
        </div>
        <div class="fun-content">
          <ul class="fun-nav">
            <li
              v-for="(item,index) in funList"
              :key="item.id"
              :class="{active:funNum==index}"
              @mouseover="funOver(index)"
            >
              <svg-icon :icon-class="funNum==index?item.svgOn:item.svg" class-name="fun_nav_svg"></svg-icon>
              <span>{{item.name}}</span>
            </li>
          </ul>

          <div
            class="fun-row"
            v-for="(item,index) in funList"
            :key="item.id"
            v-show="index == funNum"
          >
            <div class="fun-row-svg">
              <svg-icon :icon-class="item.path" class-name="fun_nav_svg"></svg-icon>
            </div>
            <div class="fun-row-info">
              <h3 class="fun-h3">{{item.content}}</h3>

              <to-try class-name="c-link" type="1"></to-try>
            </div>
          </div>
        </div>
      </div>
    </div>

    <to-try class-name="c-apply" type="2"></to-try>
  </div>
</template>
<script>
export default {
  data() {
    return {
      banner: {
        title: "厚科盘点机",
        desc: "智能化盘点，快、准、省\n更快捷，更精准，更省成本"
      },
      advantageList: [
        {
          svg: "check_advantage_svg1",
          name: "快捷",
          content: "分批盘点，实现边销边盘"
        },
        {
          svg: "check_advantage_svg2",
          name: "精确",
          content: "盘点数据精准，告别错盘漏盘"
        },
        {
          svg: "check_advantage_svg3",
          name: "同步",
          content: "实时同步单据，实时库存查询"
        },
        {
          svg: "check_advantage_svg4",
          name: "先进",
          content: "采用先进的采码技术和进口的扫描头，确保扫码精准"
        }
      ],
      funNum: 0,
      funList: [
        {
          svg: "check_fun_svg1",
          svgOn: "check_fun_svgOn1",
          path: "check_fun_pic1",
          name: "动销盘点",
          content: "支持动销盘点，实现边销边盘，告别停业式盘点"
        },
        {
          svg: "check_fun_svg2",
          svgOn: "check_fun_svgOn2",
          path: "check_fun_pic2",
          name: "实时库存",
          content: "实时查询库存，了解库存情况"
        },
        {
          svg: "check_fun_svg3",
          svgOn: "check_fun_svgOn3",
          path: "check_fun_pic3",
          name: "条码打印",
          content: "支持条码打印，可批量打印条码，完成扫码盘点"
        },
        {
          svg: "check_fun_svg4",
          svgOn: "check_fun_svgOn4",
          path: "check_fun_pic4",
          name: "一键录单",
          content: "一键录购进、退货、互调单"
        }
      ]
    };
  },
  methods: {
    funOver(index) {
      this.funNum = index;
    }
  }
};
</script>
<style lang='scss' scoped>
$color: #213d81;
/deep/ .c-link {
  background: $color;
}
/deep/ .c-apply {
  color: $color;
  background: $color;
}

/deep/ .productBg {
  background-image: url("../../assets/imgs/banner_check.png");
}
.m-title {
  h2 {
    &::after {
      content: "";
      background: $color;
    }
  }
}
.advantage {
  width: 100%;
  height: 574px;
  background: #f3f5f8;
  padding: 72px 0 0;
  .advantage-nav {
    @include clearfix;
    li {
      float: left;
      width: 282px;
      height: 273px;
      border-radius: 10px;
      padding: 48px 16px;
      background: #fff;
      &:not(:last-child) {
        margin-right: 24px;
        p {
          text-align: center;
        }
      }
      .advantage-svg {
        display: block;
        width: 64px;
        height: 64px;
        margin: 0 auto;
      }
      h3 {
        font-size: 22px;
        font-weight: 300;
        color: #000;
        line-height: 30px;
        text-align: center;
        margin-top: 24px;
      }
      p {
        font-size: 16px;
        font-weight: 300;
        color: #6c737d;
        line-height: 25px;
        margin-top: 16px;
      }
    }
  }
}

.fun {
  padding: 72px 0 92px;
  .fun-content {
    @include clearfix;
    .fun-nav {
      width: 230px;
      float: left;
      li {
        width: 100%;
        height: 100px;
        padding: 0 24px;
        display: flex;
        align-items: center;
        color: #2f393f;
        cursor: pointer;
        .fun_nav_svg {
          font-size: 56px;
          margin-right: 24px;
        }
        span {
          font-size: 22px;
          font-weight: 300;
        }
      }
      .active {
        color: $color;
      }
    }
    .fun-row {
      float: left;
      margin-left: 32px;
      @include clearfix;
      .fun-row-svg {
        float: left;
        width: 610px;
        height: 433px;
        .fun_nav_svg {
          width: 610px;
          height: 433px;
        }
      }

      .fun-row-info {
        float: left;
        margin: 32px 0 0 32px;
        .fun-h3 {
          width: 286px;
          font-size: 24px;
          font-weight: 300;
          color: #2f393f;
          line-height: 32px;
        }
      }
    }
  }
}
</style>
